import { gql } from '@apollo/client'

export const GET_PERSON_NOTES = gql`
  query getPersonNotes($id: Int!) {
    person(id: $id) {
      id
      notes {
        id
        account_id
        content
        created_at
        created_by {
          id
          last_name
          first_name
        }
        creator_name
      }
      person_properties {
        id
        property {
          id
          name
        }
      }
    }
  }
`

export const GET_NOTE_USERS = gql`
  query GetNoteUsers {
    users {
      id
      email
      first_name
      last_name
      user_property {
        property {
          id
          name
        }
      }
    }
  }
`

export const GET_PERSON_PROPERTIES = gql`
  query GetPersonPropertiesForNotes($personId: ID!) {
    person_properties(personId: $personId) {
      id
      property {
        id
      }
    }
  }
`
